import React, { useEffect } from "react";
import FAQS from "../Components/FAQS";
import Hero from "../Components/Hero";
import HowWorks from "../Components/HowWorks";
import WhyUs from "../Components/WhyUs";
import Speciality from "../Components/Speciality";
import { Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import qrcode from "../assets/qr.png"
import wchannel from "../assets/wchannel.png"
import play from "../assets/play.png"

const Home = () => {
  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  return (
    <>
      <Hero />
      <HowWorks />
      <WhyUs />

      <section className="text-white py-5 mt-10" style={{ background: "#fc364e" }}>
        <div className="canvas py-3">
          <div className="row align-items-center justify-content-between flex-wrap">
            <div className="col-xxl-5 col-md-6 col-12 text-center d-flex flex-md-row flex-column gap-xxl-5 gap-md-3 align-items-center justify-content-between  text-md-start mb-4 mb-md-0">
              <img src={qrcode} className="qrcode" />
              <div className="text-center mt-md-0 mt-3">
                <h2 class="fw-bold text-center mb-3 fs-2">
                  Únete a nuestro <br /> #canaltransferven
                </h2>

                <img
                  src={wchannel}
                  className="channel-img"
                  alt="logo"
                />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-md-6 col-xxl-5 col-12 text-center text-md-center d-flex flex-md-row flex-column justify-content-between  align-items-center gap-xxl-5 gap-md-3 ">
              <h3 className={window.matchMedia("(max-width: 700px)").matches ? "display-1 fw-bold" : "fw-bold display-5"}>
                ¡Rápido,<br />
                Simple,<br />
                Seguro!
              </h3>

              <div className="mt-md-0 mt-3">
                <h2 class="fw-bold text-center mb-3 fs-2">
                  Descarga nuestra <br /> #apptransferven
                </h2>
                <Link to="https://play.google.com/store/apps/details?id=com.transferven.app" target="_blank"
                  className="btn btn-primary-custom d-inline-flex align-items-center gap-2 px-4 py-2 mb-md-0 mb-4">
                  <img src={play} height={40} />
                </Link>
              </div>

            </div>
          </div>
        </div>
      </section>
      <Speciality />

      <FAQS />
    </>
  );
};

export default Home;
